// removed by extract-text-webpack-plugin
module.exports = {"About":"About__About__1fxsG","Row":"About__Row__26ZlG","Three":"About__Three__9I37I","Pic":"About__Pic__2_5ZA","WriteUp":"About__WriteUp__19_q3","Contact":"About__Contact__qbvB-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/About/About.css
// module id = 115
// module chunks = 0